import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-window" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-waiting-screen" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dialog-waiting" }, [
    /*#__PURE__*/_createElementVNode("svg", null, [
      /*#__PURE__*/_createElementVNode("use", { href: "#animation-waiting" })
    ])
  ])
], -1)
const _hoisted_3 = { class: "login-window-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1)
const _hoisted_5 = ["inner-html"]
const _hoisted_6 = { class: "login-form input-form" }
const _hoisted_7 = { class: "intro" }
const _hoisted_8 = { class: "input-pair" }
const _hoisted_9 = { class: "input-cell" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "input-pair" }
const _hoisted_12 = { class: "input-cell" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "buttons normal-and-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_validation_summary = _resolveComponent("validation-summary")!
  const _component_icon_inline = _resolveComponent("icon-inline")!
  const _component_scanner_listener = _resolveComponent("scanner-listener")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["login-screen", _ctx.cssClass])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: "title",
            "inner-html": _ctx.l.welcome
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.l.instruction), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.userName) = $event)),
                placeholder: _ctx.l.userName,
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => {_ctx.submit();}, ["enter"]))
              }, null, 40, _hoisted_10), [
                [_vModelText, _ctx.model.userName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.password) = $event)),
                placeholder: _ctx.l.password,
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => {_ctx.submit();}, ["enter"]))
              }, null, 40, _hoisted_13), [
                [_vModelText, _ctx.model.password]
              ])
            ])
          ]),
          _createVNode(_component_validation_summary, {
            modelValue: _ctx.model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model) = $event)),
            "validation-title": _ctx.shared.validation.validationSummary
          }, null, 8, ["modelValue", "validation-title"]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              class: "button normal",
              onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.submit();})
            }, _toDisplayString(_ctx.l.submit), 1),
            _createElementVNode("a", {
              class: "button icon-only",
              onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.scanCode();})
            }, [
              _createVNode(_component_icon_inline, { icon: "fa-qrcode" })
            ])
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_scanner_listener, { onCodeScanned: _ctx.codeScanned }, null, 8, ["onCodeScanned"])
  ], 64))
}